import {SALPrinterActions} from "../actions/SALPrinterActions";
import {ResponseStatus} from "../../utils/ResponseStatus";
import {Endpoints} from "../../utils/network/Enpoints";
import {axiosGET} from "../../utils/network/NetworkUtils";
import {callNative, NativeActions, NativeCommands} from "../../utils/NativeBridge";

export function getSALFormat(dispatcher, printerType) {
    dispatcher({type: SALPrinterActions.LOADING})
    const params = {
        params: {
            printerType: printerType
        }
    };
    getSALFormatForStation(dispatcher, params);
}


async function getSALFormatForStation(dispatcher, params) {
    try {
        const response = await axiosGET("getSALFormatForStation", Endpoints.GET_SAL_FORMAT, params);
        if (response.data.responseCode === ResponseStatus.SUCCESS) {
            dispatcher({
                type: SALPrinterActions.GET_SAL_FORMAT_RESPONSE,
                responseCode: response.data.responseCode,
                printerFormat: response.data.printerFormat
            });
            callNative(NativeActions.PRINT, NativeCommands.SET_SAL_FORMAT, {
                "printer_type": "avery",
                "format": encodeURI(response.data.printerFormat),
                "label_tag": "InductSAL"
            });
        }
        else {
            dispatcher({
                type: SALPrinterActions.GET_SAL_FORMAT_RESPONSE_ERROR,
                responseCode: ResponseStatus.ERROR,
            });
        }
    } catch(error) {
        // See: https://github.com/axios/axios/issues/383#issuecomment-234079506
        if (!error.status) {
            dispatcher({
                type: SALPrinterActions.GET_SAL_FORMAT_RESPONSE_ERROR,
                responseCode: ResponseStatus.ERROR,
            });
        }
        else {
            dispatcher({
                type: SALPrinterActions.GET_SAL_FORMAT_RESPONSE_ERROR,
                responseCode: ResponseStatus.ERROR,
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/scanPrinter/network/SALPrinterNetworkAPI.js